<template>
    <div class="main pb-24 container mx-auto">
        <div class="w-full max-w-xs mx-auto pt-16">
            <h1 class="text-center" v-text="$t('LOGIN_FRIEND')"></h1>
            <login-form
                :show-reset-password="false"
                redirect-path-after-login="/dashboard"
                :is-canvasser="true"/>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/forms/auth/LoginForm';

export default {
    name: 'Login',
    components: {
        LoginForm,
    },
};
</script>
